export const getBaseEditorStyle = () => ({
  content: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
  },
  formFooter: {
    paddingTop: '15px',
  },
  cancelButton: {
    marginLeft: '8px',
  },
  saveButton: {
    '&.btn-default': {
      color: '#ffffff',
      backgroundColor: '#0078d4',
    },
    '&.btn-default[disabled]': {
      backgroundColor: '#f3f2f1',
      color: '#323130',
    },
  },
});
